import { z } from 'zod';
import {
  temperatureSchema,
  vehicleTypesSchema,
  vehicleGroupSchema,
  vehicleTrailerTypeSchema,
  vehicleBrandSchema,
  weightSchema,
} from '../../common';
import { floatNumSchema } from '../../validation';

//* trailer
export const vehicleTrailerSchema = z.object({
  /** in meters */
  length: floatNumSchema,
  /** in meters */
  height: floatNumSchema,
  /** in meters */
  width: floatNumSchema,
  /** type of trailer */
  type: z.array(vehicleTrailerTypeSchema).min(1),
  /** the temperature that a vehicle can handle */
  temperature: temperatureSchema,
  /** the max load weight of the truck can handle */
  loadWeight: weightSchema,
});
export type VehicleTrailer = z.infer<typeof vehicleTrailerSchema>;

//* color
export const vehicleColorSchema = z.enum(['blue', 'red', 'green', 'black', 'white']);
export type VehicleColor = z.infer<typeof vehicleColorSchema>;

//* classification
export const vehicleClassificationSchema = z.object({
  /** the group that the vehicle belongs to such as (Truck group /Lorry group / Sedan group / etc).
   *
   * Derived from `type` by the backend selector — kept required on the
   * stored record but does not need to be sent by the client.
   */
  group: vehicleGroupSchema,
  /** the full truck type. Hard requirement on vehicle creation. */
  type: vehicleTypesSchema,
  /** the box/trailer and its specs.
   *
   * Derived from `type` by the backend selector — kept required on the
   * stored record but does not need to be sent by the client.
   */
  trailer: vehicleTrailerSchema,
  /** brand of the vehicle. Optional — recommended for Logisti integration. */
  brand: vehicleBrandSchema.optional(),
  /** the color of the vehicle written in the registration. Optional — recommended for Logisti. */
  color: vehicleColorSchema.optional(),
  /** the year of the vehicle made. Optional — recommended for Logisti. */
  year: z.coerce.number().min(1980).optional(),
});
export type VehicleClassification = z.infer<typeof vehicleClassificationSchema>;
